import React, { useMemo } from "react";
import { PageContainer, PageTitleBadge, DataGridTable } from "../components";
import { GiCow } from "react-icons/gi";
import "./TestDataGrid.css";

export default function TestDataGrid() {
  // Données fictives pour tester le tableau
  const fakeData = useMemo(() => [
    {
      id: 1,
      matricule: "AN001",
      sexe: "M",
      age: 3,
      race: "Zebu",
      robe: "Rouge",
      statut: "actif",
      categorie: "Bovin",
      valeur: 150000,
      ranch_provenance: "Ranch A",
      date_naissance: "2021-05-15",
    },
    {
      id: 2,
      matricule: "AN002",
      sexe: "F",
      age: 2,
      race: "N'Dama",
      robe: "Blanc",
      statut: "actif",
      categorie: "Bovin",
      valeur: 120000,
      ranch_provenance: "Ranch B",
      date_naissance: "2022-03-20",
    },
    {
      id: 3,
      matricule: "AN003",
      sexe: "M",
      age: 5,
      race: "Zebu",
      robe: "Noir",
      statut: "vendu",
      categorie: "Bovin",
      valeur: 180000,
      ranch_provenance: "Ranch A",
      date_naissance: "2019-08-10",
    },
    {
      id: 4,
      matricule: "AN004",
      sexe: "F",
      age: 4,
      race: "N'Dama",
      robe: "Rouge",
      statut: "actif",
      categorie: "Bovin",
      valeur: 140000,
      ranch_provenance: "Ranch C",
      date_naissance: "2020-11-25",
    },
    {
      id: 5,
      matricule: "AN005",
      sexe: "M",
      age: 1,
      race: "Zebu",
      robe: "Blanc",
      statut: "actif",
      categorie: "Bovin",
      valeur: 90000,
      ranch_provenance: "Ranch B",
      date_naissance: "2023-07-05",
    },
    {
      id: 6,
      matricule: "AN006",
      sexe: "F",
      age: 6,
      race: "N'Dama",
      robe: "Noir",
      statut: "mort",
      categorie: "Bovin",
      valeur: 0,
      ranch_provenance: "Ranch A",
      date_naissance: "2018-02-14",
    },
    {
      id: 7,
      matricule: "AN007",
      sexe: "M",
      age: 3,
      race: "Zebu",
      robe: "Rouge",
      statut: "actif",
      categorie: "Bovin",
      valeur: 160000,
      ranch_provenance: "Ranch C",
      date_naissance: "2021-09-30",
    },
    {
      id: 8,
      matricule: "AN008",
      sexe: "F",
      age: 2,
      race: "N'Dama",
      robe: "Blanc",
      statut: "actif",
      categorie: "Bovin",
      valeur: 130000,
      ranch_provenance: "Ranch B",
      date_naissance: "2022-12-08",
    },
    {
      id: 9,
      matricule: "AN009",
      sexe: "M",
      age: 4,
      race: "Zebu",
      robe: "Noir",
      statut: "vendu",
      categorie: "Bovin",
      valeur: 170000,
      ranch_provenance: "Ranch A",
      date_naissance: "2020-04-22",
    },
    {
      id: 10,
      matricule: "AN010",
      sexe: "F",
      age: 3,
      race: "N'Dama",
      robe: "Rouge",
      statut: "actif",
      categorie: "Bovin",
      valeur: 145000,
      ranch_provenance: "Ranch C",
      date_naissance: "2021-10-15",
    },
  ], []);

  // Configuration des colonnes (similaire à Animaux)
  const columns = useMemo(() => [
    {
      field: "matricule",
      headerName: "Matricule",
      flex: 1,
      minWidth: 140,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: "sexe",
      headerName: "Sexe",
      width: 90,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: "age",
      headerName: "Age",
      width: 90,
      type: "number",
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: "race",
      headerName: "Race",
      flex: 1,
      minWidth: 140,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: "robe",
      headerName: "Robe",
      flex: 1,
      minWidth: 140,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: "statut",
      headerName: "Statut",
      width: 130,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const getStatusClass = (statut) => {
          switch (statut) {
            case 'actif':
              return 'status-actif';
            case 'mort':
              return 'status-mort';
            case 'vendu':
              return 'status-vendu';
            default:
              return '';
          }
        };
        return (
          <span className={getStatusClass(params.value)}>
            {params.value}
          </span>
        );
      },
    },
    {
      field: "categorie",
      headerName: "Catégorie",
      flex: 1,
      minWidth: 140,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: "valeur",
      headerName: "Valeur",
      width: 110,
      type: "number",
      headerAlign: 'right',
      align: 'right',
      valueFormatter: (value) => {
        if (!value) return "0";
        return new Intl.NumberFormat('fr-FR').format(value);
      },
    },
    {
      field: "ranch_provenance",
      headerName: "Ranch de provenance",
      flex: 1,
      minWidth: 160,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: "date_naissance",
      headerName: "Date",
      width: 130,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (value, row) => {
        if (!row?.date_naissance) return "N/A";
        const date = new Date(row.date_naissance);
        return date.toLocaleDateString('fr-FR');
      },
    },
  ], []);

  return (
    <PageContainer>
      <PageTitleBadge title="TEST DATAGRID TABLE" icon={<GiCow />} />
      
      <div style={{ marginTop: "32px" }}>
        <DataGridTable
          rows={fakeData}
          columns={columns}
          loading={false}
          storageKey="test-datagrid-zoom-level"
          initialSort={{ field: 'matricule', sort: 'asc' }}
          pageSize={25}
        />
      </div>
    </PageContainer>
  );
}

